<h1 mat-dialog-title>{{ data.title }}</h1>

<mat-dialog-content>
  <div class="row main-row">
    <div class="col-12 p-5 align-items-center justify-content-center">
      <video id="idVideo" preload="auto" controls autoplay width="100%" height="auto">
        <source src="assets/video/{{ data.videoName }}.mp4" type="video/mp4">
        <source src="assets/video/{{ data.videoName }}.webm" type="video/webm">
        <source src="assets/video/{{ data.videoName }}.ogv" type="video/ogg">
      </video>
    </div>
  </div>
</mat-dialog-content>

<div class="row custom-dialog-footer">
  <div class="col-12 col-md-6 text-left">
    <a mat-raised-button [color]="data.btnCancelColor" (click)="onDenial()">
      <mat-icon fontSet="fal" [fontIcon]="data.btnCancelIcon"></mat-icon>
      {{ data.btnCancelText }}
    </a>
  </div> <!-- /.col -->
  <div class="col-12 col-md-6 text-right">
  </div> <!-- /.col -->
</div> <!-- /.row -->